// packages import
import { yupResolver } from '@hookform/resolvers/yup'
import { Box, IconButton, Typography } from '@mui/material'
import { FC } from 'react'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
// component import
import SaveRoundedIcon from '@mui/icons-material/SaveRounded'
import { Alert } from '../../common/Alert'
import { CustomController } from '../../common/CustomController'
// others
import { useUpdateUserGeneralInfoMutation, UserStatus } from '../../../../generated'
import { USER_UPDATE_SUCCESS } from '../../../constants'
import { DispatchAndState, UpdateEmailInputProps } from '../../../interfaceTypes'
import { updateEmailSchema } from '../../../validationSchema'
import { UserAction, UserState } from '../userReducer'

export const UpdateEmail: FC<DispatchAndState<UserState, UserAction>> = ({ state, refetch }) => {
  const { currentUser } = state || {}
  const { id, email, status } = currentUser || {}

  const updateEmailMethods = useForm<UpdateEmailInputProps>({
    mode: 'all',
    resolver: yupResolver(updateEmailSchema),
    defaultValues: {
      id,
      email: email || ''
    }
  })

  const { handleSubmit: updateEmailHandleSubmit, setValue } = updateEmailMethods

  const [updateUserGeneralInfoMutation, { loading }] = useUpdateUserGeneralInfoMutation({
    onError(error) {
      const { graphQLErrors } = error
      if (graphQLErrors) {
        graphQLErrors.map(({ message }) => {
          Alert.error(message)
        })
      }
    },
    onCompleted(data) {
      if (data) {
        const { updateUserGeneralInfo } = data
        const { response, user } = updateUserGeneralInfo || {}
        if (response) {
          const { status: responseStatus } = response
          if (responseStatus === 200) {
            Alert.success(USER_UPDATE_SUCCESS)
            if (user) {
              setValue('email', user.email || '')
            }
            refetch?.()
          }
        }
      }
    }
  })

  const emailSubmitHandler: SubmitHandler<UpdateEmailInputProps> = async (data: UpdateEmailInputProps) => {
    await updateUserGeneralInfoMutation({
      variables: {
        user: {
          id: id || '',
          email: data.email
        }
      }
    })
  }

  return (
    <FormProvider {...updateEmailMethods}>
      <form onSubmit={updateEmailHandleSubmit(emailSubmitHandler)}>
        <Box pb={2}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box flex={1}>
              <Typography variant="h5" fontSize="14px">
                Email:
              </Typography>
            </Box>

            <IconButton type="submit" aria-label="Save" disabled={status !== UserStatus.Active || loading}>
              <SaveRoundedIcon color={status === UserStatus.Active ? 'primary' : 'disabled'} />
            </IconButton>
          </Box>

          <CustomController controllerName="email" controllerLabel="Email" fieldType="text" />
        </Box>
      </form>
    </FormProvider>
  )
}
